// src/components/ui/feedback/BusinessBadge/BusinessBadge.jsx
import React from 'react';
import { Building2 } from 'lucide-react';
import { cn } from '../../../../utils/cn';

const BusinessBadge = ({
  businessName,
  className = '',
  variant = 'emerald', // emerald, blue, purple
  size = 'md' // sm, md, lg
}) => {
  // Size configurations
  const sizeConfig = {
    sm: {
      container: "px-3 py-1.5 text-xs gap-1.5",
      icon: "w-3 h-3"
    },
    md: {
      container: "px-4 py-2 text-sm gap-2", 
      icon: "w-4 h-4"
    },
    lg: {
      container: "px-5 py-2.5 text-base gap-2.5",
      icon: "w-5 h-5"
    }
  };

  // Variant styles matching the partner signup design
  const variantStyles = {
    emerald: cn(
      "bg-emerald-900/20 border border-emerald-500/30 text-emerald-300"
    ),
    blue: cn(
      "bg-blue-900/20 border border-blue-500/30 text-blue-300"
    ),
    purple: cn(
      "bg-purple-900/20 border border-purple-500/30 text-purple-300"
    )
  };

  const currentSize = sizeConfig[size];

  return (
    <div className={cn(
      // Base styles
      "inline-flex items-center rounded-xl font-medium backdrop-blur-sm",
      
      // Size styles
      currentSize.container,
      
      // Variant styles
      variantStyles[variant],
      
      className
    )}>
      {/* Building Icon */}
      <Building2 className={currentSize.icon} />
      
      {/* Business Name */}
      <span className="font-medium">
        {businessName}
      </span>
    </div>
  );
};

export default BusinessBadge;